export const handleChangeDataModalAddresses = (name, value) => ({
    type: 'CHANGE_DATA_MODAL_ADDRESSES', name, value
});